const palette = {
  primary: {
    contrastText: '#FFFFFF',
    dark: '#03904F',
    main: '#03A65B',
    mediumLight: '#c2ddd0ff',
    light: '#D8F4E7',
    screen: '#f1f9f3',
    border: '#03A65B'
  },
  secondary: {
    contrastText: '#FFFFFF',
    dark: '#0457D2',
    main: '#106EFA',
    light: '#6896FB'
  },
  error: {
    contrastText: '#FFFFFF',
    dark: '#EC2F31',
    main: '#FF4E50',
    light: '#FE989A'
  },
  warning: {
    background: '#f9f1e3',
    border: '#FFD48C',
    contrastText: '#FFFFFF',
    dark: '#DC8C08',
    main: '#F5A623',
    light: '#FFD48C',
    text: '#A55B2B',
    screen: '#FDFCF6'
  },
  info: {
    contrastText: '#FFFFFF',
    dark: '#266DD7',
    main: '#3989FF',
    light: '#98C5FF',
    notice: '#98c5ff66',
    screen: '#f2f5fe'
  },
  success: {
    contrastText: '#FFFFFF',
    dark: '#5F9422',
    main: '#93C954',
    light: '#CCEDA6'
  },
  text: {
    primary: '#3A3C45',
    secondary: '#71737F',
    disabled: '#C6CCDA'
  },
  link: '#106EFA',
  icon: '#757783',
  background: {
    default: '#F9FAFD',
    paper: '#FFFFFF',
    secondary: '#F2F4FA',
    info: '#F5F5F5',
    disabled: '#828599',
    error: '#FE989A26'
  },
  divider: '#C6CCDA',
  border: '#dbe0eb'
};

export default palette;
